import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import Container from './FlashMessages/Container';
import Message from './FlashMessages/Message';

// TODO: use something better for key here
/* eslint-disable react/no-array-index-key */
export default function FlashMessages({ messages }) {
    return (
        <Container>
            {messages.map((message, idx) => <Message key={idx} {...message} />,)}
        </Container>
    );
}
/* eslint-enable react/no-array-index-key */

FlashMessages.displayName = displayName('FlashMessages');

FlashMessages.propTypes = {
    messages: PropTypes.array.isRequired,
};
